import React, { useState } from 'react';
import './PastEventsShowcase.css';
import pastEvent1 from '../../assets/WhoWeAre.jpg';
import pastEvent2 from '../../assets/WhoWeAre1.jpg';
import pastEvent3 from '../../assets/WhoWeAre2.jpg';
import pastEvent4 from '../../assets/WhoWeAre3.jpg';
import pastEvent5 from '../../assets/WhoWeAre4.jpg';


const PastEventsShowcase = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const events = [
    {
      id: 1,
      title: "Qiskit Fall Fest",
      category: "Bootcamp",
      image: pastEvent1
    },
    {
      id: 2,
      title: "Quantumke",
      category: "Bootcamp",
      image: pastEvent2
    },
    {
      id: 3,
      title: "Africa Quantum Summit",
      category: "Conference",
      image: pastEvent3
    },
    {
      id: 4,
      title: "Quantumke",
      category: "Workshop",
      image: pastEvent4
    },
    {
      id: 5,
      title: "Quantumke",
      category: "Meetup",
      image: pastEvent5
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % events.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + events.length) % events.length);
  };

  return (
    <div className="past-events-section">
      <div className="past-events-section__container">
        {/* Header Section */}
        <div className="past-events-section__header">
          <span className="past-events-section__category-tag">Past Events</span>
          <h2 className="past-events-section__title">See What We've Done Before</h2>
        </div>

        {/* Carousel Section */}
        <div className="past-events-section__carousel">
          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="past-events-section__nav-button past-events-section__nav-button--prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <button onClick={nextSlide} className="past-events-section__nav-button past-events-section__nav-button--next">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>

          {/* Slides Container */}
          <div className="past-events-section__slides-wrapper">
            <div 
              className="past-events-section__slides-container"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {events.map((event) => (
                <div key={event.id} className="past-events-section__slide">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="past-events-section__slide-image"
                  />
                  <div className="past-events-section__slide-content">
                    <span className="past-events-section__event-category">{event.category}</span>
                    <h3 className="past-events-section__event-title">{event.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Slide Indicators */}
          <div className="past-events-section__indicators">
            {events.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`past-events-section__indicator ${
                  currentSlide === index ? 'past-events-section__indicator--active' : ''
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PastEventsShowcase;